<template>
  <div class="pc-account-page">
    <!-- PC端头部（与首页统一） -->
    <header class="pc-header">
      <div class="header-container">
        <div class="logo">
          <img src="/img/study.png" alt="logo" class="logo-img" />
          <span class="logo-title">上岸</span>
        </div>
        <nav class="nav-menu">
          <a href="/" class="nav-item">首页</a>
          <a href="/#project" class="nav-item">课程</a>
          <a href="/#about" class="nav-item">关于我们</a>
        </nav>
        <div class="user-actions">
          <span class="user-name">
            欢迎您，{{ $store.getters.name || '请登录' }}
          </span>
          <button class="btn-mine-outline" @click="goHome">返回首页</button>
        </div>
      </div>
    </header>

    <!-- 账户管理内容区 -->
    <section class="account-section-wrap">
      <div class="container">
        <div class="account-layout">
          <!-- 侧边栏 -->
          <aside class="account-sidebar">
            <div class="sidebar-user">
              <div class="sidebar-avatar">{{ ($store.getters.name || 'U').charAt(0).toUpperCase() }}</div>
              <div class="sidebar-name">{{ $store.getters.name }}</div>
              <div class="sidebar-device" v-if="currentDevice !='unknown'">{{ currentDevice }}</div>
            </div>
            <nav class="sidebar-nav">
              <a class="sidebar-nav-item active" href="javascript:;">
                <i class="cubeic-lock"></i>
                安全设置
              </a>
            </nav>
          </aside>

          <!-- 主内容 -->
          <main class="account-main">
            <div class="main-header">
              <h2 class="main-title">安全设置</h2>
              <p class="main-desc">修改您的登录密码</p>
            </div>

            <div class="main-body">
              <cube-form ref="pwdForm" :model="pwdModel" :schema="pwdSchema" @submit="submitPwd"></cube-form>

              <div class="form-actions">
                <button type="button" class="btn-submit" @click="submitPwdForm">确认修改</button>
                <button type="button" class="btn-logout" @click="logout">退出登录</button>
              </div>
            </div>
          </main>
        </div>
      </div>
    </section>

    <!-- PC端页脚（与首页统一） -->
    <footer class="pc-footer">
      <div class="container">
        <div class="footer-content">
          <div class="footer-section">
            <h3>关于我们</h3>
            <p>致力于为学习者提供优质的在线教育资源，助力每个人实现学习目标。</p>
          </div>
        </div>
        <div class="footer-bottom">
          <p>© 2025 ShangAn. All rights reserved.</p>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { changePwd } from "@/api/login";
import { getModels } from "@/services/device";

export default {
  name: 'AccountPC',
  data() {
    return {
      currentDevice: "",
      pwdModel: {
        o_password: "",
        n_password: "",
        n_password2: ""
      },
      pwdSchema: {
        fields: [
          {
            type: "input",
            modelKey: "o_password",
            label: "原始密码",
            props: {
              placeholder: "请输入原始密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              required: true
            },
            trigger: "blur",
            messages: {
              required: "原始密码为必填项"
            }
          },
          {
            type: "input",
            modelKey: "n_password",
            label: "新密码",
            props: {
              placeholder: "请输入新密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              required: true,
              min: 6,
              max: 16,
              checkopwd: val => {
                return resolve => {
                  if (val == this.pwdModel.o_password) {
                    resolve(false);
                  } else {
                    resolve(true);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "新密码为必填项",
              checkopwd: "新密码不能与原始密码相同"
            }
          },
          {
            type: "input",
            modelKey: "n_password2",
            label: "确认新密码",
            props: {
              placeholder: "请再次输入新密码",
              type: "password",
              eye: { open: false }
            },
            rules: {
              required: true,
              min: 6,
              max: 16,
              pwdcheck: val => {
                return resolve => {
                  if (val == this.pwdModel.n_password) {
                    resolve(true);
                  } else {
                    resolve(false);
                  }
                };
              }
            },
            trigger: "blur",
            messages: {
              required: "请再次输入新密码",
              pwdcheck: "两次密码输入不一致"
            }
          }
        ]
      }
    };
  },
  methods: {
    goHome() {
      this.$router.push("/");
    },
    submitPwdForm() {
      this.$refs.pwdForm.submit();
    },
    async submitPwd(e, { o_password, n_password }) {
      e.preventDefault();
      try {
        const res = await changePwd(
            this.$store.getters.name,
            o_password,
            n_password
        );
        if (res.status === 200) {
          this.$createToast({
            txt: res.data.message,
            type: "success",
            time: 1000
          }).show();
          setTimeout(() => {
            this.logout();
          }, 1000);
        }
      } catch (err) {
        this.$createToast({
          txt: err,
          type: "error",
          time: 1500
        }).show();
      }
    },
    logout() {
      this.$store.dispatch("FedLogOut").then(() => {
        this.$router.push("/redirect/login");
      });
    }
  },
  created() {
    this.currentDevice = getModels().join(" or ");
  }
};
</script>

<style>
@import "../assets/stytels/home-pc.css";

.pc-account-page {
  min-height: 100vh;
  background: #f0f2f5;
  display: flex;
  flex-direction: column;
}

/* 账户内容区 */
.account-section-wrap {
  flex: 1;
  margin-top: 200px;
}

.account-layout {
  display: flex;
  gap: 24px;
  align-items: flex-start;
}

/* 侧边栏 */
.account-sidebar {
  width: 260px;
  flex-shrink: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.sidebar-user {
  text-align: center;
  padding: 32px 20px 24px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: #fff;
}

.sidebar-avatar {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 24px;
  font-weight: 700;
  margin: 0 auto 12px;
  border: 2px solid rgba(255, 255, 255, 0.3);
}

.sidebar-name {
  font-size: 18px;
  font-weight: 600;
}

.sidebar-device {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.7);
  margin-top: 6px;
}

.sidebar-nav {
  padding: 12px 0;
}

.sidebar-nav-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 12px 24px;
  color: #666;
  font-size: 15px;
  text-decoration: none;
  transition: all 0.2s;
  border-left: 3px solid transparent;
}

.sidebar-nav-item:hover {
  color: #667eea;
  background: #f8f9ff;
}

.sidebar-nav-item.active {
  color: #667eea;
  background: #f0f0ff;
  border-left-color: #667eea;
  font-weight: 600;
}

/* 主内容区 */
.account-main {
  flex: 1;
  min-width: 0;
  background: #fff;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.main-header {
  padding: 28px 32px 0;
}

.main-title {
  font-size: 22px;
  color: #1a1a2e;
  margin: 0 0 6px;
}

.main-desc {
  font-size: 14px;
  color: #999;
  margin: 0;
}

.main-body {
  padding: 24px 32px 32px;
}

/* 表单样式 */
.main-body .cube-form {
  background: transparent;
}

.main-body .cube-form .cube-form-item {
  margin-bottom: 4px;
}

.main-body .cube-form .cube-form-label {
  font-size: 14px;
  color: #333;
  font-weight: 500;
  padding: 16px 0 6px;
}

.main-body .cube-form .cube-input {
  border: 1px solid #d9d9d9;
  border-radius: 8px;
  background: #fff;
  padding: 0 14px;
  transition: border-color 0.2s, box-shadow 0.2s;
}

.main-body .cube-form .cube-input:focus-within {
  border-color: #667eea;
  box-shadow: 0 0 0 2px rgba(102, 126, 234, 0.15);
}

.main-body .cube-form .cube-input-field {
  height: 42px;
  font-size: 14px;
}

.main-body .cube-form .cube-input_error {
  border-color: #ff4757;
}

.main-body .cube-form .cube-input_active {
  box-shadow: none;
}

.main-body .cube-form .cube-form-validator {
  font-size: 12px;
  margin-top: 4px;
}

/* 按钮区 */
.form-actions {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  margin-top: 32px;
  padding-top: 24px;
  border-top: 1px solid #f0f0f0;
}

.btn-submit {
  padding: 8px 28px;
  border: none;
  border-radius: 8px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: #fff;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.2s;
}

.btn-submit:hover {
  opacity: 0.9;
}

.btn-logout {
  padding: 8px 20px;
  border: 1px solid #e8e8e8;
  border-radius: 8px;
  background: #fff;
  color: #ff4757;
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
}

.btn-logout:hover {
  color: #ff6b81;
  border-color: #ffd7d7;
  background: #fff5f5;
}
</style>
